module.exports = __webpack_public_path__ + "static/WindingWorlds3-9e895dd150e16c20844c86fd2ed9b89f.webp";